import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_TARIFF_SIMULATION_ORDER: {
      return { ...action.tariffSimulationOrder };
    }
    default:
      return state;
  }
};
